import numeral from 'numeral';

export function objectIsEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function notNullNorUndefined(someVar) {
    return someVar !== null && someVar !== undefined;
}

export function getNetworkErrors(error) {
    return error.networkError.response.json().then(e => e.errors.map(e => e.message).join(','))
}

export function mapById(objectList) {

    let rebuiltObject = [];

    rebuiltObject._index = {};
    rebuiltObject.updateIndex = function() {
        for (let i = 0; i < this.length; i++) {
            this._index[this[i].id] = i;
        }
    };
    rebuiltObject.add = function(object) {
        this.push(object);
        this._index[object.id] = this.length -1;
    };
    rebuiltObject.getById = function(id) {
        return this[this._index[id]];
    };
    rebuiltObject.getIndexById = function(id) {
        return this._index[id];
    };

    for (let i = 0 ; i < objectList.length; i++) {
        rebuiltObject.add(objectList[i])
    }

    return rebuiltObject;
}

export function getFlooredFixed(x, d = 4) {
    x = x * Math.pow(10, d);

    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x) / Math.pow(10, d);
    }
    return Math.ceil(x) / Math.pow(10, d);
}

export function money(number, currency) {
    if (isNaN(number) || !notNullNorUndefined(number)) {
        return '';
    }

    if (notNullNorUndefined(currency) && currency.length > 0) {
        return currency + " " + numeral(number).format('0,0.000').replace(/,/g, " ");

        /*return number.toLocaleString('en-US', {
            style: 'currency',
            currency: currency,
        }).replace(/,/g, " ").replace(currency, currency + " ");*/
    } else {
        return number.toLocaleString('en-US', {
            style: 'decimal',
        }).replace(/,/g, " ");
    }
}

export function percent(number) {
    if (isNaN(number) || !notNullNorUndefined(number)) {
        return '';
    }
    return number.toFixed(3).toLocaleString('en-US', {
        style: 'percent',
    }).replace(/,/g, " ");
}

export function nl2br(str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}



// WEBPACK FOOTER //
// ./src/utils/utils.js